import React, { createContext, useContext, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { TestTakerPopup } from '.'
import { useSelector } from 'react-redux';
import { testTakerRQ } from 'store/hooks';
import { useQuery } from '@tanstack/react-query';
import { getSchoolClassesFetch } from 'store/middlewares/testTakers.crud';
import { AbilityContext } from 'components/Permissions/Can';
import { alerts as alertKeys } from 'keys'
import { useDispatch } from 'react-redux';
import mockSchools from 'mock/schools'
import qc from 'keys/queryClient';
import Papa from 'papaparse';
import allClassess from "mock/classess"
import schoolsFile from 'mock/Schools.csv';

const RegirsterWrap = () => {
    const formname = "test_taker"
    const { state } = useLocation()
    const dispatch = useDispatch()

    const { affiliations } = useSelector(state => state.affiliation)
    const { defaultRole } = useSelector(state => state.user)
    const { alerts } = useSelector(state => state.general)
    const { grades, schoolClasses } = useSelector(state => state.testTaker)

    const ability = useContext(AbilityContext)
    const initialValues = alerts[alertKeys.createTestTaker]?.props
    const formValues = useSelector(state => state.form[formname]?.values)
    const tzRef = useRef()

    const [schools, setSchools] = useState(null)
    const [tzApproved, setTzApproved] = useState(initialValues?.test_taker_id ? true : false)

    const { role_name } = defaultRole || {}
    const allDataOpen = (
        // כרגע אנחנו מבטלים את האפשרות למשתמש עם תפקיד יחידני גישה לכל הבתי ספר
        // allRoles?.[role_name] == roleTypes.single ||// כשיוצרים תלמיד מסוג תפקיד כמו מורה פרטית, מאפשרים כרגע גישה לכלל הבתי ספר TODO 
        ability.can("manage", "super_user")) && // משתמש סופר יוזר יכול ליצור תלמיד לכל הבתי ספר 
        !initialValues?.school // כמגיעים עם בית ספר קיים אנו נציג רק את הבתי ספר הקיימים מהDB ולא נציג את כלל הבתי ספר

    const allGrades = testTakerRQ.useGetAllGrades()
    const cleanState = () => window.history.replaceState({}, '')

    const classes = useQuery({
        queryKey: [qc.classes, formValues?.grade?.id, formValues?.school?.id],
        queryFn: async () => {
            const { data } = await getSchoolClassesFetch(formValues)
            return data
        },
        enabled: !!(formValues?.grade?.id && formValues?.school?.id)
    })

    useEffect(() => {
        window.addEventListener("beforeunload", cleanState);
        return () => {
            window.removeEventListener("beforeunload", cleanState);
        };
    }, []);

    useEffect(() => {
        if (!schools)
            fetch(schoolsFile)
                .then(response => response.text())
                .then(csvData => {
                    Papa.parse(csvData, {
                        header: true,
                        complete: (results) => {
                            setSchools([...mockSchools, ...results.data])
                        },
                        error: (error) => {
                            console.error('CSV Parsing Error:', error);
                        }
                    });
                })
                .catch(error => {
                    console.error('Error fetching CSV file:', error);
                });
    }, [])

    // useEffect(() => {
    //     // במקרה ששם הורה ריק
    //     if(!formValues?.parent_last_name)
    //     // מיועד לפעם הראשונה שיוצרים תלמיד, שדה שם משפחה הורה מתמלא אוטומטי משם משפחה של התלמיד
    //    // במקרה שמדובר בשורה אדומה 
    //     if (formValues?.last_name && (formValues.invalid  || !formValues?.id))
    //         dispatch(change(formname, 'parent_last_name', formValues?.last_name))
    // }, [formValues?.last_name])

    // כל שינוי של תעודת הזהות מעדכן את התעודה כלא מאושרת
    useEffect(() => {
        if (tzRef.current && tzRef.current != formValues?.tz)
            setTzApproved(false)
        tzRef.current = formValues?.tz
    }, [formValues?.tz])

    const commonValue = {
        initialValues,
        schools: allDataOpen ? schools : affiliations,
        // בעבר היה פתוח רק השכבות והכיתות הרלוונטיות אבל בגלל שזה הקשה על הצוות לעמוד בכ"כ הרבה בקשות לפתיחת שכבות וכיתות הוחלט לפתוח את האפשרות לכלל המשתמשים
        grades: allGrades.data,
        schoolClasses: allClassess,
        tzApproved, setTzApproved,
        formname: "test_taker"
        // schoolClasses: allDataOpen ? allClassess : classes?.data,
        //TODO לעדכן את השכבות שישאב אוטומטית לפי המוסד, כרגע לא מבצע את זה
        // grades: allDataOpen ? allGrades.data : grades
    }

    return (
        <CreateTestTakerContext.Provider value={commonValue}>
            <TestTakerPopup />
        </CreateTestTakerContext.Provider>
    )
}

export const CreateTestTakerContext = createContext()
export default RegirsterWrap